document.addEventListener('DOMContentLoaded', function () {
  (function () {
    if (window.__pcVariantThumbsInitialized) return;
    window.__pcVariantThumbsInitialized = true;

  function isColorName(value) {
    return value === 'color' || value === 'farbe';
  }

  function getColorNameFromFieldset(fieldset) {
    if (!fieldset) return null;
    var legend = fieldset.querySelector('legend');
    if (!legend) return null;
    return legend.textContent.split(':')[0].trim().toLowerCase();
  }

  function isColorSelect(select) {
    var name = select.getAttribute('name') || '';
    var match = name.match(/^options\[(.+)\]$/);
    if (!match) return false;
    return isColorName(match[1].trim().toLowerCase());
  }

  function getColorRadioGroup(variantSelects) {
    var fieldsets = variantSelects.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      if (isColorName(getColorNameFromFieldset(fieldsets[i]))) return fieldsets[i];
    }
    return null;
  }

  function getSelectedColorValue(variantSelects) {
    if (!variantSelects) return null;

    var colorFieldset = getColorRadioGroup(variantSelects);
    if (colorFieldset) {
      var checked = colorFieldset.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
    }

    var selects = variantSelects.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) {
      if (!isColorSelect(selects[i])) continue;
      return selects[i].value;
    }

    return null;
  }

  function getColorValueFromSelectionIds(variantSelects, selectedOptionValues) {
    if (!variantSelects || !Array.isArray(selectedOptionValues)) return null;

    for (var i = 0; i < selectedOptionValues.length; i++) {
      var selector = '[data-option-value-id="' + selectedOptionValues[i] + '"]';
      var element = variantSelects.querySelector(selector);
      if (!element) continue;

      if (element.tagName === 'INPUT') {
        var fieldset = element.closest('fieldset');
        if (fieldset && isColorName(getColorNameFromFieldset(fieldset))) return element.value;
      }

      if (element.tagName === 'OPTION') {
        var select = element.closest('select');
        if (select && isColorSelect(select)) return element.value;
      }
    }

    return null;
  }

    function isSameValueCaseInsensitive(valueA, valueB) {
      return (
        typeof valueA === 'string' &&
        typeof valueB === 'string' &&
        valueA.toLowerCase() === valueB.toLowerCase()
      );
    }

  function syncActiveThumb(variantSelects, colorValue) {
    if (!variantSelects || !colorValue) return;

    var productInfo = variantSelects.closest('product-info') || document;
    var thumbContainer = productInfo.querySelector('.pc-variant-thumbs');
    if (!thumbContainer) return;

    var thumbs = thumbContainer.querySelectorAll('.pc-variant-thumb');
    thumbs.forEach(function (thumb) {
      thumb.classList.toggle('is-active', isSameValueCaseInsensitive(thumb.dataset.optionValue, colorValue));
    });
  }

  function triggerColorSelection(button) {
    var colorValue = button.dataset.optionValue;
    if (!colorValue) return;

    var productInfo = button.closest('product-info') || document;
    var variantSelects = productInfo.querySelector('variant-selects');
    if (!variantSelects) return;

    var colorFieldset = getColorRadioGroup(variantSelects);
    if (colorFieldset) {
      var radios = colorFieldset.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (!isSameValueCaseInsensitive(radios[i].value, colorValue)) continue;
        if (!radios[i].checked) {
          radios[i].click();
        }
        return;
      }
    }

    var selects = variantSelects.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      if (!isColorSelect(selects[j])) continue;
      if (!isSameValueCaseInsensitive(selects[j].value, colorValue)) {
        selects[j].value = colorValue;
        selects[j].dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
  }

  function syncFromVariantSelects(variantSelects) {
    syncActiveThumb(variantSelects, getSelectedColorValue(variantSelects));
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.pc-variant-thumb');
    if (!button) return;
    triggerColorSelection(button);
  });

  document.querySelectorAll('variant-selects').forEach(function (variantSelects) {
    syncFromVariantSelects(variantSelects);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (payload) {
      var variantSelects =
        payload &&
        payload.data &&
        payload.data.event &&
        payload.data.event.target &&
        payload.data.event.target.closest('variant-selects');

      if (!variantSelects) {
        variantSelects =
          payload &&
          payload.data &&
          payload.data.target &&
          payload.data.target.closest &&
          payload.data.target.closest('variant-selects');
      }

      if (variantSelects) {
        var selectedOptionValues = payload && payload.data && payload.data.selectedOptionValues;
        var selectedColor = getColorValueFromSelectionIds(variantSelects, selectedOptionValues);
        syncActiveThumb(variantSelects, selectedColor || getSelectedColorValue(variantSelects));
      }
    });
  }
  })();
});
